module.exports = __webpack_public_path__ + "01_long_brown.276e8845.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_long_brown.png
// module id = GadC
// module chunks = 0